import ee from 'event-emitter';

export const emitter = ee();

export const WS_RECEIVE_MESSAGE_EVENT = 'wsReceiveMessage';
